import { ReactNode } from 'react';

import styles from './ManualWrapper.module.css';

const ManualWrapper = ({ children }: { children: ReactNode }) => {
  return <main className={styles.wrapper}>{children}</main>;
};

export default ManualWrapper;
